/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  OnInit,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SelectModule } from "primeng/select";
import { COUNTRIES, Country } from "../../core/constants/countries";

@Component({
  selector: "app-country-select",
  imports: [CommonModule, FormsModule, SelectModule],
  templateUrl: "./country-select.component.html",
  styleUrl: "./country-select.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountrySelectComponent),
      multi: true,
    },
  ],
})
export class CountrySelectComponent implements ControlValueAccessor, OnInit {
  @Input() placeholder: string = "Select Country";
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() styleClass: string = "w-full";
  @Input() appendTo: string | HTMLElement | null = null;
  @Output() selectionChange = new EventEmitter<string>();

  countries: Country[] = COUNTRIES;
  countryOptions: { label: string; value: string }[] = [];
  selectedValue: string | null = null;

  private onChange: (value: string | null) => void = () => {};
  private onTouched: () => void = () => {};

  ngOnInit(): void {
    // Convert countries to dropdown options
    this.countryOptions = this.countries.map((c) => ({
      label: c.name,
      value: c.alpha2,
    }));
  }

  // ControlValueAccessor implementation
  writeValue(value: string | null): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Handle selection change
  onCountryChange(event: any): void {
    const value = event.value;
    this.selectedValue = value;
    this.onChange(value);
    this.onTouched();
    this.selectionChange.emit(value);
  }
}
